class AutomaticReportDTO {
  constructor(report, defaultDevice) {
    this.name = report.name;
    this.reportType = report.reportType;
    this.groups = [];
    this.daysNumber = report.daysNumber;
    this.mailReportDestinations = [];
    this.ftpReportDestinations = [];
    this.startDate = `${report.startDate}`;
    this.monthInterval = report.monthInterval;
    this.dayInterval = report.dayInterval;
    this.hourInterval = report.hourInterval;
    this.minuteInterval = report.minuteInterval;
    this.cron = report.cron;
    this.fileType = report.fileType;
    this.fileEncoding = report.fileEncoding;
    this.enabled = (report.enabled === undefined) ? false : report.enabled;
    this.sendNow = (report.sendNow === undefined) ? false : report.sendNow;
    this.mailReportDestinations = [];
    this.ftpReportDestinations = [];
    this.checkId(report.id);
    this.checkGroupsOrSerials(report, defaultDevice);
    this.setDeliveries(report.delivery);
    this.locale = this.setLocale(report.locale);
  }

  checkGroupsOrSerials(report, defaultDevice) {
    if (report.reportType !== 'HOURLY' && report.reportType !== 'HOURLY_WEATHER') {
      if (report.selectedGroups !== undefined) {
        report.selectedGroups.forEach((group) => {
          this.groups.push(group.id);
        });
      }
    } else if (report.serialNumber !== undefined) {
      this.serialNumber = report.serialNumber;
    } else {
      this.serialNumber = defaultDevice;
    }
  }

  checkId(value) {
    if (value > 0) {
      this.id = value;
    }
  }

  setDeliveries(deliveries) {
    deliveries.forEach((delivery) => {
      if (delivery.selectedType === 'e-mail') {
        this.mailReportDestinations.push({
          mail: delivery.mail,
        });
      } else {

        this.ftpReportDestinations.push(
          {
            host: delivery.host,
            directory: delivery.directory || '/',
            user: delivery.user,
            password: delivery.password,
            ssl: delivery.ssl,
            passive: delivery.passive,
          },
        );
      }
    });
  }

  setLocale(locale) {
    if (locale === undefined) {
      return 'pl-PL';
    }
    return locale;
  }
}

export default AutomaticReportDTO;
